import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=98839c66&scoped=true&"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=98839c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98839c66",
  null
  
)

export default component.exports